import { post } from "state/actions/api";

export const syncTheme = (context) => (theme) => {
    return post(context)(`console/themes/${theme}/sync`, {}, "syncTheme");
};
